module.exports = __webpack_public_path__ + "img/img95.a78859e8.svg";